<template>
  <div class="index-content3">
    <div class="title-container">
      <div class="title-dec-left">
        <img src="@/assets/image/title-dec.png" alt="title decoration left" />
      </div>
      <div class="title-text">代理收益模型</div>
      <div class="title-dec-right">
        <img src="@/assets/image/title-dec.png" alt="title decoration right" />
      </div>
    </div>
    <div class="tip">一次推广，永享收益分成</div>
    <div class="content-show-container">
      <div
        v-for="(item, index) in itemList"
        :key="index"
        class="item"
      >
        <div class="title">
          <div class="title-text">{{ item.title }}</div>
          <div class="percent">{{ item.percent100 }}</div>
        </div>
        <Progress :percentage="item.percent" :fill-color="item.color" />
      </div>
      <div class="tip-btn">优秀城市代理年收益可达50万+</div>
    </div>
  </div>
</template>

<script>
import Progress from './progress.vue';

export default {
  name: 'CityContent3',
  components: {
    Progress,
  },
  data() {
    return {
      itemList: [
        {
          title: '软件授权费',
          percent100: '30%',
          percent: 0.3,
          color: 'linear-gradient(180deg, #FFB0AE 0%, #FF0000 100%)',
        },
        {
          title: '年度服务费',
          percent100: '30%',
          percent: 0.3,
          color: 'linear-gradient(180deg, #FFAEFE 0%, #D621FF 100%)',
        },
        {
          title: '各项增值服务',
          percent100: '30%',
          percent: 0.3,
          color: 'linear-gradient(180deg, #61F4FF 0%, #2583E8 100%)',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.index-content3 {
  width: 100%;
  height: auto;
  margin-top: 53px;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  .title-container {
    height: 43px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
    gap: 12px;
    
    .title-dec-left {
      img {
        width: 75px;
        height: 26px;
        display: block;
        object-fit: contain;
      }
    }
    
    .title-text {
      font-weight: 700;
      font-size: 30px;
      color: #FFFFFF;
      align-self: flex-end;
      line-height: 1;
    }
    
    .title-dec-right {
      img {
        width: 75px;
        height: 26px;
        display: block;
        object-fit: contain;
        transform: scaleX(-1);
      }
    }
  }
  
  .tip {
    font-weight: 500;
    font-size: 19px;
    color: #FFFFFF;
    text-align: center;
    margin-top: 10px;
  }
  
  .content-show-container {
    width: 826px;
    height: 587px;
    background: linear-gradient(89deg, #212A92 0%, rgba(135, 65, 209, 0.6) 100%);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin-top: 35px;
    padding: 60px 100px;
    
    .item {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      width: 100%;
      margin-bottom: 42px;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .title {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 18px;
        
        .title-text {
          font-weight: 500;
          font-size: 24px;
          color: #FFFFFF;
        }
        
        .percent {
          font-weight: 500;
          font-size: 24px;
          color: #FFFFFF;
        }
      }
    }
    
    .tip-btn {
      width: 622px;
      height: 83px;
      background: linear-gradient(98deg, #7845FF 0%, #D16EFB 100%);
      box-shadow: inset 0px 4px 10px 0px rgba(255, 255, 255, 0.5);
      border-radius: 12px;
      font-weight: 500;
      font-size: 30px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: auto;
    }
  }
}
</style>
